import * as C from '../constants';
import reducer from '../reducers';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware } from 'redux';

const middleware = [thunk];
const logger = createLogger({
  collapsed: true,
});

const isDev = process.env.NODE_ENV !== C.PRODUCTION;

if (isDev) {
  middleware.push(logger);
}

// const enhancer = composeWithDevTools(applyMiddleware(...middleware));
const enhancer =
  isDev && window.navigator.userAgent.includes('Chrome')
    ? composeWithDevTools(applyMiddleware(...middleware))
    : applyMiddleware(...middleware);
const store = createStore(reducer, {}, enhancer);

export default store;
